import React, { useEffect, useRef } from 'react';
import { scrollState } from '@/lib/depth';

/**
 * Fixed background layers. The ember atmosphere fades in as the camera
 * descends past the threshold (driven by scrollState.blend each frame).
 */
export const Atmosphere = () => {
  const emberRef = useRef(null);

  useEffect(() => {
    let raf;
    const tick = () => {
      if (emberRef.current) {
        emberRef.current.style.opacity = scrollState.blend.toFixed(3);
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="fixed inset-0 z-0 pointer-events-none" aria-hidden="true">
      {/* opaque base removed so the DioramaZoom hero images show through; the
          root/body bg-background still provides the dark base behind them */}
      <div ref={emberRef} className="absolute inset-0 ember-atmosphere" style={{ opacity: 0 }} data-testid="ember-atmosphere" />
      <div className="absolute inset-0 vignette" />
    </div>
  );
};
